import HitTypes from 'models/search/hit_types';

export default function ensureFilterTypeSet(query) {
  if (query.filter.type || query.filter.types) {
    return query;
  }
  query.setFilterProperties({ types: [HitTypes.CONVERSATION, HitTypes.TASK] });
  return query;
}
